export default {
  fillInOrder: 'Startseite-Bestellung ausfüllen',
  inputTips: "(Spalten mit <span style='color: red'>*</span> sind Pflichtfelder)",
  process: {
    first: 'Bestellung ausfüllen & absenden',
    second: 'Produkt & Inlandsversandkosten bezahlen',
    three: 'Warten Sie, bis Ihr Produkt im Lager eintrifft',
  },
  productInfo: 'Produktinformationen',
  productInfoTips:
    'Alle Produkte, die für den Startseiteen-Service auf acbuy angezeigt werden, sind Produkte, die von Drittanbieter-Shopping-Plattformen abgerufen werden und nicht direkt von acbuy verkauft werden. Daher trägt im Falle einer Verletzungsproblematik durch die vorgenannten Produkte die alleinige Haftung der entsprechende Verkäufer auf der Drittanbieter-Plattform, während acbuy keine diesbezügliche, zusätzliche oder gesamtschuldnerische Haftung übernimmt.',
  fees: 'Gebühren',
  feeStandard: 'Gebührenstandards',
  feeStandardTips:
    'Für die Startseite-Bestellung, die Sie auf dieser Seite einreichen, besteht bei Produkten von Drittanbieter-Plattformen wie Kongfuzi Used Books, Xiaohongshu und Youzan usw. die Möglichkeit, dass das Produkt nicht gekauft werden kann. Für das Produkt bestehen Versandrisiken oder es können zusätzliche Servicegebühren anfallen. Die tatsächliche Servicegebühr muss vom Agenten überprüft werden. Weitere Informationen finden Sie unter „Hilfe-Center – Gebührenstandards für den Startseiteen-Service von Drittanbietern“.',
  link: 'Link',
  name: 'Name',
  remark: 'Bemerkung',
  unitPrice: 'Stückpreis (CNY)',
  qty: 'Menge',
  goodsAttr: 'Spezifikationen oder Material',
  chinaPostage: 'Versandkosten (CNY)',
  holder: {
    inputUrl: 'Bitte fügen Sie die Produkt-URL ein',
    inputName: 'Bitte geben Sie hier den Produktnamen ein (innerhalb von 100 Zeichen)',
    inputAttr: 'Bitte geben Sie die Spezifikationen des Produkts ein',
    inputRemark:
      'Wenn der Artikel verschiedene Muster, Größen, Farben usw. hat, geben Sie bitte hier an, was Sie benötigen, basierend auf der Klassifizierungsbeschreibung auf der Produktseite. Wenn Sie dasselbe Produkt, aber mit unterschiedlichen Spezifikationen kaufen, trennen Sie bitte die Bestellung.',
    contactName: 'Bitte geben Sie Ihren Kontaktnamen ein',
    contactEmail: 'Bitte geben Sie Ihre Kontakt-E-Mail-Adresse ein',
    contactPhone: 'Bitte geben Sie Ihre Kontakttelefonnummer ein',
  },
  other: 'Sonstige (optional)',
  productImg: 'Produktbilder',
  fareTip:
    'Die Inlandsversandkosten zu unserem Lager (wenn Sie unsicher sind, geben Sie bitte 0 ein, der Agent wird dies überprüfen und eine Zahlung veranlassen)',
  customizedLogisticsForm: 'Formular für kundenspezifische Logistikanträge',
  submitInfo: 'Produktinformationen übermitteln',
  customizedProcess: {
    first: 'Bestellung ausfüllen & absenden',
    second: 'Produktinformationen übermitteln',
    three: 'Warten Sie, bis acbuy Sie kontaktiert',
  },
  deliveryAddress: 'Lieferadresse',
  contactDetail: 'Kontaktdetails',
  contactName: 'Kontaktname',
  contactPhone: 'Telefonnummer',
  contactEmail: 'E-Mail',
  customizedLogisticsInformation: 'Informationen zur kundenspezifischen Logistik',
  fromWarehouse: 'Vom Lager',
  manuallyFill: 'Produktinformationen manuell eingeben',
  contactInfoTips1:
    '· Um Ihnen besser dienen zu können, füllen Sie das Formular bitte wahrheitsgemäß und detailliert aus. Innerhalb von drei Werktagen nach Einreichung des Antrags wird sich ein zuständiger Mitarbeiter mit Ihnen in Verbindung setzen.',
  contactInfoTips2:
    '· Für Pakete unter 30 kg wird Kunden empfohlen, die Online-Logistiklieferung zu wählen.',
  contactInfoTips3:
    '· Kundenspezifische Dienstleistungen umfassen nur den Logistiktransport, und die Waren werden nur auf ihr Aussehen geprüft, eine detaillierte Qualitätsprüfung der Waren erfolgt nicht.',
  myWarehouse: 'Mein Lager',
  itemName: 'Artikelname',
  volume1: 'Abmessungen des Pakets nach dem Verpacken',
  volume: 'Volumen (cm)',
  weight: 'Gewicht',
  length: 'Länge',
  width: 'Breite',
  height: 'Höhe',
  warehouseItem: 'Lagerartikel',
  manuallyItem: 'Manueller Artikel',
  submitSuccess: 'Antrag für kundenspezifische Logistik erfolgreich eingereicht',
  submitMsg: 'Wir werden Sie so schnell wie möglich kontaktieren, bitte haben Sie Geduld.',
  inputProductMsg: 'Bitte geben Sie die Produktinformationen ein',
  selectZone: 'Bitte wählen Sie die Vorwahl für die Kontakttelefonnummer',
  productName: 'Produktlink oder -name',
}
